import {
  useItems,
  useDictionary,
  useClient,
  OEAsset,
} from "@adamlip/okeoke.client"
import ContentBox from "components/ContentBox"
import { useEffect, useState } from "react"

function CategoryCards({ setSelectedCategory }) {
  const { getName } = useClient()
  const { categoryTree, categories } = useItems()
  const { getValue } = useDictionary()

  const [itemList, setItemList] = useState([])

  useEffect(() => {
    const list = categoryTree.filter(
      (category) =>
        (category.availability?.availableItems > 0 ||
          category.availability?.availableSubItems > 0) &&
        (category.availability?.visibleItems > 0 ||
          category.availability?.visibleSubItems > 0)
    )
    setItemList(list)
  }, [categoryTree])

  if (itemList.length === 0)
    return (
      <div
        id="orderItemList-byCategory"
        className="orderItemList-byCategory-root"
      >
        <div className="no-order-items text-center">
          {getValue("app_v2_orderItemList_no_orders")}
        </div>
      </div>
    )

  return (
    <div className="category-cards-root">
      <ContentBox place="before_category_list" />
      {itemList.map((categ) => (
        <div
          key={categ.uuid}
          className="category-card md:!w-[180px]"
          onClick={() => setSelectedCategory(categ.uuid)}
        >
          <div className={`h-[80px]`}>
            <OEAsset
              uuid={categories?.[categ.uuid]?.attributes?.appImage || ""}
              size="l"
              addClass="object-cover"
            />
          </div>
          <div className="category-name truncate">
            {getName(categories?.[categ.uuid]?.name)}
          </div>
        </div>
      ))}
    </div>
  )
}
export default CategoryCards
